import $ from 'jquery';


class EditableFooter {

	constructor() {
		if ($("#editable_footer").length> 0) {
			this.init();
		}
	}

	init() {

		Vue.component('editable-footer', () => import('../components/EditableFooter.vue'));


			let vm = new Vue({
				el: '#editable_footer',
				data: {
					
				},
				methods: {
				}
			});
			

	}


}

export default EditableFooter;
